import { useMemo } from 'react';
import parseUserAgent from '@appscore/device-detector';
import { getWindow } from '@app/shared/utils/window';

function useIsWebView() {
  const isCustomWebView = useMemo(() => {
    const windowObject = getWindow();
    if (!windowObject) return false;
    const deviceInfo = parseUserAgent(windowObject.navigator.userAgent);
    const { deviceType } = deviceInfo;
    return deviceType === 'WEBVIEW';
  }, []);
  return isCustomWebView;
}
export default useIsWebView;
